import _ from "lodash";
import moment from 'moment';
const config = (context) => {
    return {
        hideListHeader: true,
        editPath: "products",
        pageTitle: "Products",
        pageIcon: "devices",
        listQueryId: "searchProductServicesCustom",
        responseFieldName: "searchProductServices",
        linkRows: false,
        searchRecordsInput: false,
        hideActionColumn: true,
        columns: {
            processor: { label: "Processor", sortable: true},
            status: { label: "Status", sortable: true },
            company: { label: "Company", sortable: true },
            portfolio: { label: "Portfolio", sortable: true },
            account: { label: "Account", sortable: true },
            merchantNumber: { label: "Merchant Number", sortable: true },
            approvalDate: { label: "Approval Date", sortable: true, dateFilter: true },
            isRestructured: { label: "Restructured", sortable: true },
            proposalStatementValue: { label: "Proposal / Statement Volume", sortable: true },
            avgTrxAmount: { label: "Proposal Average Ticket", sortable: true },
            category: { label: "Category", sortable: true },
            model: { label: "Model", sortable: true },
            cashDiscount: { label: "Cash Discount", sortable: true },
            billToService: { label: "Bill To Service", sortable: true },
            billingMethod: { label: "Bill to Method", sortable: true },
        },
        ignoreSortColumns: [
            "processor",
            "status",
            "company",
            "portfolio",
            "account",
            "merchantNumber",
            "approvalDate",
            "isRestructured",
            "proposalStatementValue",
            "avgTrxAmount",
            "category",
            "model",
            "cashDiscount",
            "billToService",
            "billingMethod",
        ],
        perPageOptions: [10, 20, 25, 50],
        defaults: {
            sort: "id",
            sortDir: "desc",
            perPage: 10,
        },
        fuseSearch: null,
        formatResponse: (data)=> {
            return context.formatResponse(data);
        },
        filterResponse: (result)=> {
            return context.filterResponse(result);
        },
    };
};

export default config;
